import { render, staticRenderFns } from "./remessage.vue?vue&type=template&id=46eeba8d&"
import script from "./remessage.vue?vue&type=script&lang=js&"
export * from "./remessage.vue?vue&type=script&lang=js&"
import style0 from "./remessage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports